import { defaultFlow, ceoFlow } from "./flows";
import { QUIZ_IDS } from "./quizIds";

export const onboardingFlows = Object.freeze({
  [QUIZ_IDS.default]: defaultFlow,
  [QUIZ_IDS.ceo]: ceoFlow,
});

export const getOnboardingFlow = (quizId) => onboardingFlows[quizId];

export const checkFlow = (quizId) =>
  Object.keys(onboardingFlows).includes(quizId);
